module.exports = __webpack_public_path__ + "media/images/bg/mosaic/monitor-f17a8f9155b7695a47b2e11a1797f43b.svg";